import React, {useEffect, useState} from 'react';
import Modal from 'react-modal';

const DialogConfirm = ({open, onClose, message, onSubmit}) => {

    const handleSubmit =()=>{
        onClose();
        onSubmit();
    }
    return (
        <Modal
            isOpen={open}
            className="rounded-lg w-[270px] absolute  overflow-hidden top-1/2 left-1/2 bg-white -translate-y-2/4 -translate-x-2/4"
            contentLabel="Example Modal"
            overlayClassName="bg-black/50 w-full h-full fixed top-0 z-[1000]"
        >
            <div className="">
                <div className="p-4">
                    <h2 className="text-center font-bold text-base mb-2">Thông báo</h2>
                    <div className="text-sm text-center px-4">
                        {message}
                    </div>
                </div>
                <div className="bg-zinc-100 border border-t-gray-300 flex justify-center">
                    <button className="text-green-600 p-2 flex-1 border border-r-gray-300" onClick={onClose}>Không</button>
                    <button className="text-red-600 p-2 flex-1" onClick={handleSubmit}>Kết thúc</button>
                </div>
            </div>
        </Modal>
    )
}

export default DialogConfirm